module.exports.config = {
  "declarative": true,
  "render-module": {
    "name": "PieceHudsonRenderModule",
    "path": "front/piece-hudson-render.module"
  },
  "cms-module": {
    "name": "PieceHudsonCmsModule",
    "path": "front/piece-hudson-cms.module"
  },
  "definition": {
    "type": "pieceHudson",
    "name": "PieceHudsonDefinition",
    "group": "Carousels",
    "availablePlatforms": ["web"],
    "description": "Dash Hudson",
    "isNew": false,
    "fields": [
      {
        "name": "idAlbum",
        "label": "Id del álbum",
        "type": "plainText",
        "mandatory": true
      },
      {
        "name": "idStoryly",
        "label": "Id de Storyly",
        "type": "plainText",
        "mandatory": false
      },
      {
        "name": "apiKey",
        "label": "API Key",
        "type": "plainText",
        "mandatory": false
      },
      {
        "name": "itemsToObtain",
        "label": "Cantidad de elementos a obtener",
        "type": "plainText",
        "defaultValue": "10",
        "mandatory": true,
        "validators": ["positiveInteger"]
      },
      {
        "name": "redirectQueryParam",
        "label": "Redirección Shop The Look (xs)",
        "type": "options",
        "defaultValue": "01",
        "isExcluded": true,
        "values": [
          {
            "label": "Home",
            "value": "01"
          },
          {
            "label": "StradiLooks UGC",
            "value": "30"
          }
        ]
      },
      {
        "name": "sort",
        "label": "Ordenar por: ",
        "type": "plainText",
        "defaultValue": "ORDER",
        "mandatory": true
      },
      {
        "name": "loop",
        "label": "Loop infinito en los videos",
        "type": "boolean",
        "mandatory": true
      },
      {
        "name": "showUserName",
        "label": "Mostrar username de la influencer",
        "type": "boolean",
        "defaultValue": true,
        "mandatory": true
      },
      {
        "name": "itemsPerRowFormat",
        "type": "groupTabs",
        "flattenFields": true,
        "tabs": [
          {
            "label": "ESCRITORIO",
            "fields": ["itemsPerRowDesktop", "gridSpacingDesktop", "formatDesktop"]
          },
          {
            "label": "MÓVIL",
            "fields": ["itemsPerRowMobile", "gridSpacingMobile", "formatMobile"]
          },
        ],
        "fields": [
          {
            "name": "itemsPerRowDesktop",
            "label": "Cantidad de elementos por fila",
            "type": "plainText",
            "defaultValue": "5",
            "isExcluded": true,
            "mandatory": true,
            "validators": ["positiveInteger"]
          },
          {
            "name": "gridSpacingDesktop",
            "label": "Separación entre imágenes",
            "type": "units",
            "defaultValue": "4px",
            "disableUnits": ["%", "vw", "vh"]
          },
          {
            "name": "gridSpacingMobile",
            "label": "Separación entre imágenes",
            "type": "units",
            "defaultValue": "4px",
            "disableUnits": ["%", "vw", "vh"]
          },
          {
            "name": "itemsPerRowMobile",
            "label": "Cantidad de elementos por fila",
            "type": "plainText",
            "defaultValue": "8",
            "mandatory": true,
            "validators": ["positiveInteger"]
          },
          {
            "name": "formatDesktop",
            "label": "Formato",
            "type": "options",
            "defaultValue": "mosaic",
            "isExcluded": true,
            "values": [
              {
                "label": "Mosaico",
                "value": "mosaic"
              },
              {
                "label": "Fila",
                "value": "row",
              },
              {
                "label": "Custom",
                "value": "custom"
              }
            ]
          },
          {
            "name": "formatMobile",
            "label": "Formato",
            "type": "options",
            "defaultValue": "mosaic",
            "values": [
              {
                "label": "Mosaico",
                "value": "mosaic"
              },
              {
                "label": "Fila",
                "value": "row",
              },
              {
                "label": "Custom",
                "value": "custom"
              },
            ]
          },
        ]
      },
      {
        "type": "groupCollapsable",
        "name": "analytics",
        "label": "Analítica",
        "fields": [
          {
            "name": "id", 
            "label": "Origin",
            "placeholder": "Origin",
            "type": "plainText",
            "mandatory": false 
          },
        ]
      }
    ]
  }
};
